import "./styles.scss";

import { useState } from "react";
import { FlagIcon } from "react-flag-kit";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { termUseUS, termUseBR, termUseES } from "./ternsUse";
import { putAffiliate } from "../../../store/middleware";

function ModalTermUse({ showModal, setShowModal }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { language } = useSelector((state) => state.userReducer);
  const { affiliateInfo } = useSelector((state) => state.affiliateReducer);

  const [lang, setLang] = useState(language);

  const handleSave = async () => {
    const bodyAffiliate = {
      termsAccepted: true,
      id: affiliateInfo.id,
      userId: affiliateInfo?.userId,
      nativeLanguageId: affiliateInfo.nativeLanguageId,
      considerYourselfInfluencer: affiliateInfo?.considerYourselfInfluencer,
      followingTotalAllPlatforms: affiliateInfo?.followingTotalAllPlatforms,
    };

    await dispatch(putAffiliate(bodyAffiliate, true)).then((res) => res.success && setShowModal(false));
  };

  return (
    <Dialog
      open={showModal}
      classes="modalTermUse"
      className="modalTermUse"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="containerTermUse">
        <div className="wrapperTitleModal">
          <h3 className="title">{t("TERMS_OF_USE_AFFILIATE")}</h3>
          <div>
            <FlagIcon size={25} code="US" onClick={() => setLang("en")} />
            <FlagIcon size={25} code="BR" onClick={() => setLang("pt")} />
            <FlagIcon size={25} code="ES" onClick={() => setLang("es")} />
          </div>
        </div>

        <form className="contentTermUse">
          <div
            className="contentHtml"
            dangerouslySetInnerHTML={{ __html: lang === "es" ? termUseES : lang === "pt" ? termUseBR : termUseUS }}
          />
        </form>

        <div className="footer">
          <button className="buttonModalSave" onClick={handleSave}>
            {t("BTN_ACCEPT")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalTermUse;
